import Axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { segmentKeys } from "src/query-keys";

export function useSegmentBulkDeleteMutation(scenarioId: number | string) {
  const queryClient = useQueryClient();

  function mutationFn(scenarioId: number | string, segmentIds: number[]) {
    const url = `/planning-api/scenarios/${scenarioId}/segments/deleteBatch`;
    const data = { segmentIdList: segmentIds };
    return Axios.post(url, data);
  }

  return useMutation((segmentIds: number[]) => mutationFn(scenarioId, segmentIds), {
    onSuccess: () => {
      queryClient.invalidateQueries(segmentKeys.all(scenarioId));
    },
  });
}
